import type {NotificationMessages} from './hooks/api-with-notification/useApiWithNotifications';

export const USER_NOT_FOUND_MESSAGE = 'User not found. Please ensure that the user with this email exists in PB Admin.';
export const ALREADY_INVITED_MESSAGE = 'This user has already been invited to the portal';
export const DEBOUNCE_MS = 600;
export const MIN_SEARCH_LEN = 5;

export const createNotificationMessages = (
    actionName: string,
    entityName: string = 'item',
): NotificationMessages => ({
    success: `${actionName} completed successfully.`,
    error: `Cannot ${actionName.toLowerCase()} the ${entityName}. Please contact your PitchBook representative.`,
    exception: `An unexpected error occurred while ${actionName.toLowerCase()} the ${entityName}.`,
});

export const NOTIFICATION_TIMEOUTS = {
    successTimeout: 5000,
    errorTimeout: 6000,
    exceptionTimeout: 7000,
};

export const FILTER_WIDTH = 300;
